import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions";
import { getFeatureFlag } from "~/store/selectors/selector.featureFlags";
import { makeIsLoggedUserOwnerSelector } from "~/store/selectors/selector.users";

export const RequireCanAccessAppsAndIntegrations = ({ children, redirectTo, path }) => {
  const getIsOwner = useMemo(makeIsLoggedUserOwnerSelector, []);
  const isOwner = useSelector((state) => getIsOwner(state));

  const isMcpServerFeatureFlagOn = useSelector((state) => getFeatureFlag(state, "mcp_server"));
  const isMcpServerFeatureOn = useSelector((state) => getRawConfigOption(state, "mcp_integration_enabled"));

  const mcpServerIntegrationEnabled = path === "mcp" ? isMcpServerFeatureFlagOn && isMcpServerFeatureOn : true;

  return isOwner && mcpServerIntegrationEnabled ? children : <Navigate to={redirectTo} />;
};

RequireCanAccessAppsAndIntegrations.propTypes = {
  redirectTo: PropTypes.string,
  path: PropTypes.string,
  children: PropTypes.any,
};

RequireCanAccessAppsAndIntegrations.defaultProps = {
  redirectTo: "/not-found",
};
